/// <amd-module name="Build/Common/Artifacts/providers/Container" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes } from 'Common';
export class Container extends Base {
    public getKey() {
        return BuildArtifactTypes.Container;
    }

    public supportsDownload(): boolean {
        return true;
    }

    public supportsExploring(): boolean {
        return true;
    }
}
